import React, { useEffect, useState } from "react";
import { Box, Button, TextField, Grid2, CircularProgress } from "@mui/material";
import mail from "../../assets/images/email.svg";
import fullname from "../../assets/images/full-name.svg";
import Header from "../Header";
import Footer from "../Footer";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Link, useNavigate, useLocation } from "react-router-dom";
import useRequests from "../../utils/useRequests";
import Snackbars from "../../utils/Snackbars";
import Aadhar from "../../assets/images/aadhar2.svg";

const Profile = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { postRequest, getRequest } = useRequests();
  const [formData, setFormData] = useState({
    fullName: " ",
    email: "",
    phone: "",
    aadhar: "",
  });

  const [AlertData, setAlertData] = React.useState({
    variant: "",
    message: "",
  });
  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: "",
        message: "",
      }));
    }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
  };
  const [loading, setLoading] = useState(true);
  const [socialLogin, setSocialLogin] = useState(false);
  const fetchUserData = async () => {
    try {
      const response = await getRequest(`user-data`);
      console.log("Fetched User data:", response); // Debug log

      if (response && response.data) {
        // Access the first element of the data array
        if (response.data.social_login_provider == "Google" || response.data.social_login_provider == "Facebook") {
          setSocialLogin(true);
        }
        const {
          first_name = "",
          last_name = "",
          email = "",
          phone = "",
          aadhar = "",
        } = response.data;
        const fullName = `${first_name? first_name + " "+ last_name : ""}`;
        // Phone is stored with the +91 country code (e.g. +917620361889) but the
        // input is type="number" and the validation expects 10 digits, so strip
        // any leading + and country code for display.
        let displayPhone = phone || "";
        if (displayPhone.startsWith("+91")) {
          displayPhone = displayPhone.slice(3);
        } else if (displayPhone.startsWith("91") && displayPhone.length === 12) {
          displayPhone = displayPhone.slice(2);
        }
        displayPhone = displayPhone.replace(/\D/g, ""); // keep digits only
        setFormData({ fullName, email, phone: displayPhone, aadhar });
      } else {
        console.error("No user data found in the response.");
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching user data:", error);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchUserData();
    if (location.state && typeof location.state.message !== "undefined") {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: location.state.status,
        message: location.state.message,
      }));
      resetAlertData();
      setLoading(false);
    }
  }, []);

  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: formData,

    validationSchema: Yup.object({
      fullName: Yup.string().required("Full name is required"),
      email: Yup.string()
        .email("Please enter a valid email!")
        .max(255)
        .required("Email is required"),
      phone: Yup.string()
        .matches(/^[0-9]{10}$/, 'Please enter a valid 10-digit phone number!')
        .required('Phone number is required'),
      aadhar: Yup.string()
        .required("Aadhar number is  required")
        .matches(/^\d{12}$/, "Aadhar Card must be exactly 12 digits"),
    }),
    onSubmit: async (values) => {
      // e.preventDefault();
      try {
        const [first_name = "", ...lastNameParts] = values.fullName
          .trim()
          .split(" ");
        const last_name = lastNameParts.join(" ");
        if (!last_name) {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: "error",
            message: "Last name is required",
          }));
          resetAlertData();
          return;
        }

        let submit1 = document.getElementById("submit1");
        submit1.disabled = true;
        submit1.textContent = "Processing...";

        const jsonpar = JSON.stringify({
          first_name: first_name,
          last_name: last_name,
          email: values.email,
          phone: values.phone,
          aadhar: values.aadhar,
        });

        const res = await postRequest("update-profile", jsonpar);
        if (res && res.code === 200) {
          setAlertData({
            variant: "success",
            message: "Profile updated successfully!",
          });
          resetAlertData();
        } else {
          setAlertData({
            variant: "error",
            message: res.message || "Failed to update profile.",
          });
          resetAlertData();
        }
        submit1.disabled = false;
        submit1.textContent = "Update Profile";
      } catch (error) {
        console.error("Error: ", error);
        setAlertData({
          variant: "error",
          message: "An error occurred while updating the profile.",
        });
        resetAlertData();
      }
    },
  });
  return (
    <Box sx={{ flexGrow: 1 }}>
      <div className="center-App" container direction="column">
        <Header name="My Profile" />
        {AlertData.message !== "" ? (
          <Snackbars variant={AlertData.variant} message={AlertData.message} />
        ) : (
          ""
        )}
        <Box
          sx={{
            padding: "15px 15px",
            float: "left",
            width: "100%",
            height: "calc(100vh - 160px)",
            overflow: "auto",
          }}
        >
          <div container spacing={2}>
            <div item xs={12}>
              {loading ? (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%", // Ensure it takes full height
                    minHeight: "300px", // Set a minimum height to avoid layout collapse
                  }}
                >
                  <CircularProgress color="primary" />
                  <p>Loading ...</p>
                </Box>
              ) : (
                <form className="loginForm">
                  <div className="position-relative">
                    <img
                      src={mail}
                      alt="Logo"
                      width={24}
                      className="textboxLefticon"
                    />
                    <TextField
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      placeholder="Email ID"
                      autoComplete="off"
                      type="text"
                      name="email"
                      className={`form-control ${
                        validation1.touched.email && validation1.errors.email
                          ? "is-invalid"
                          : ""
                      }`}
                      value={validation1.values.email || ""}
                      onChange={validation1.handleChange}
                      onBlur={validation1.handleBlur}
                      invalid={
                        validation1.touched.email && validation1.errors.email
                          ? true
                          : false
                      }
                    />
                    {validation1.touched.email && validation1.errors.email ? (
                      <div className="invalid-feedback">
                        {validation1.errors.email}
                      </div>
                    ) : null}
                  </div>

                  <div className="position-relative">
                    <img
                      src={mail}
                      alt="Logo"
                      width={24}
                      className="textboxLefticon"
                    />
                    <TextField
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      placeholder="Phone"
                      autoComplete="off"
                      type="number"
                      name="phone"
                      className={`form-control ${
                        validation1.touched.phone && validation1.errors.phone
                          ? "is-invalid"
                          : ""
                      }`}
                      value={validation1.values.phone || ""}
                      onChange={validation1.handleChange}
                      onBlur={validation1.handleBlur}
                      invalid={
                        validation1.touched.phone && validation1.errors.phone
                          ? true
                          : false
                      }
                      disabled={true}
                    />
                    {validation1.touched.phone && validation1.errors.phone ? (
                      <div className="invalid-feedback">
                        {validation1.errors.phone}
                      </div>
                    ) : null}
                  </div>


                  <div className="position-relative fullName">
                    <img
                      src={fullname}
                      alt="Full Name"
                      width={19}
                      className="textboxLefticon"
                    />
                    <TextField
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      placeholder="Full Name"
                      autoComplete="off"
                      type="text"
                      name="fullName"
                      className={`form-control ${
                        validation1.touched.fullName &&
                        validation1.errors.fullName
                          ? "is-invalid"
                          : ""
                      }`}
                      value={validation1.values.fullName || ""}
                      onChange={validation1.handleChange}
                      onBlur={validation1.handleBlur}
                      invalid={
                        validation1.touched.fullName &&
                        validation1.errors.fullName
                          ? true
                          : false
                      }
                    />
                    {validation1.touched.fullName &&
                    validation1.errors.fullName ? (
                      <div className="invalid-feedback">
                        {validation1.errors.fullName}
                      </div>
                    ) : null}
                  </div>
                  <div className="position-relative fullName">
                    <img
                      src={Aadhar}
                      alt="Logo"
                      width={30}
                      className="textboxLefticon aadhar"
                    />
                    <TextField
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      placeholder="Aadhar Card"
                      autoComplete="off"
                      type="text"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      name="aadhar"
                      className={`form-control ${
                        validation1.touched.aadhar && validation1.errors.aadhar
                          ? "is-invalid"
                          : ""
                      }`}
                      value={validation1.values.aadhar || ""}
                      onChange={validation1.handleChange}
                      onBlur={validation1.handleBlur}
                      invalid={
                        validation1.touched.aadhar && validation1.errors.aadhar
                          ? true
                          : false
                      }
                    />
                    {validation1.touched.aadhar && validation1.errors.aadhar ? (
                      <div className="invalid-feedback">
                        {validation1.errors.aadhar}
                      </div>
                    ) : null}
                  </div>
                  <Grid2 className="button-bottom fullWidth mt-3" fullWidth>
                    <Button
                      className="btn-common"
                      variant="contained"
                      color="primary"
                      fullWidth
                      id="submit1"
                      onClick={(e) => {
                        e.preventDefault();
                        validation1.handleSubmit();
                        return false;
                      }}
                    >
                      {"Update Profile"}
                    </Button>
                    {
                        socialLogin == true? "" :
                        <Link to={"/change-password"}>
                      <Button
                        className="btn-common-border"
                        type="submit"
                        variant="contained"
                        color="primary"
                        fullWidth
                        sx={{ marginTop: 2 }}
                      >
                        Change Password
                      </Button>
                    </Link>
                    }
                    
                  </Grid2>
                </form>
              )}
            </div>
          </div>
        </Box>
        <Footer />
      </div>
    </Box>
  );
};

export default Profile;
